// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { cartPageContainerStyles } from "@awc/Overrides/Widgets/Cart/CartPageContainer";
import { xScreen } from "@awc/XDL/Utilities";
import { css } from "styled-components";

cartPageContainerStyles.container = {
    css: css`
        display: grid;
        grid-template-columns: 1fr minmax(280px, 448px);
        column-gap: 16px;
        ${xScreen("lte", "sm")} {
            grid-template-columns: 1fr;
            column-gap: 0;
        }
    `,
};

cartPageContainerStyles.headerContainer = {
    css: css`
        grid-column: 1 / 3;
        grid-row: 1 / 2;
    `,
};
cartPageContainerStyles.fulfillmentMethodContainer = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 2 / 3;
    `,
};

cartPageContainerStyles.cartLinesContainer = {
    css: css`
        grid-column: 1 / 2;
        grid-row: 3 / 4;
    `,
};

cartPageContainerStyles.cartTotalContainer = {
    css: css`
        grid-column: 2 / 3;
        grid-row: 2 / 4;

        ${xScreen("lte", "sm")} {
            grid-column: 1 / 2;
            grid-row: 4 / 5;
        }
    `,
};

cartPageContainerStyles.messages = {
    css: css`
        grid-column: 1 / 3;
        grid-row: 4 / 5;
        ${xScreen("lte", "sm")} {
            grid-row: 5 / 6;
        }
    `,
};

cartPageContainerStyles.productCarouselContainer = {
    css: css`
        grid-column: 1 / 3;
        grid-row: 5 / 6;
        ${xScreen("lte", "sm")} {
            grid-row: 6 / 7;
        }
    `,
};
